import React, { Component, Fragment } from "react";
import { defineMessages, FormattedMessage } from "react-intl";
import { getBankInfoErrors, trimBankInfo } from "../utils";
import Form from "assets/scripts/components/common/form/Form/Form";
import BankInfoFields from "../BankInfoFields/BankInfoFields";
const messages = defineMessages({
    bankInfoIdLabel: {
        id: "forms.payNow.bankInfoId.label",
        defaultMessage: "Select Account"
    },
    routingNumberLabel: {
        id: "forms.payNow.routingNumber.label",
        defaultMessage: "Routing Number"
    },
    routingNumberHelp: {
        id: "forms.payNow.routingNumber.help",
        defaultMessage: "Example: 123456789"
    },
    accountNumberLabel: {
        id: "forms.payNow.accountNumber.label",
        defaultMessage: "Account Number"
    },
    accountNumberHelp: {
        id: "forms.payNow.accountNumber.help",
        defaultMessage: "Example: 12345678"
    },
    accountTypeLabel: {
        id: "forms.payNow.accountType.label",
        defaultMessage: "Account Type"
    },
    saveBankInfoLabel: {
        id: "forms.payNow.saveBankInfo.label",
        defaultMessage: "Save bank account for future use?"
    },
    bankInfoNameLabel: {
        id: "forms.payNow.bankInfoName.label",
        defaultMessage: "Bank Name (optional)"
    },
    newBankAccount: {
        id: "forms.payNow.bankInfoId.options.newBankAccount",
        defaultMessage: "Use a new bank account"
    },
    next: {
        id: "forms.payNow.bankInfo.next",
        defaultMessage: "Next"
    }
});
export default class BankInfoForm extends Component {
    constructor() {
        super(...arguments);
        this._handleSubmit = () => {
            this.props.onChange(trimBankInfo(this.props.value));
            this.props.onContinue();
        };
        this._renderButtons = ({ renderSubmitButton }) => {
            return (<Fragment>
				<button type="button" className="btn mix-btn_fixedWidth btn-action" onClick={this.props.onBack}>
					<FormattedMessage id="forms.payNow.bankInfo.back" defaultMessage="Back"/>
				</button>
				{" "}
				{renderSubmitButton()}
			</Fragment>);
        };
    }
    render() {
        const { props } = this;
        const { value, disableBankSave } = props;
        const errors = getBankInfoErrors(value);
        const isValid = Object.values(errors).every(it => it == null);
        return (<Fragment>
				<div className="vr vr_x4">
					<h1 className="hdg">
						<FormattedMessage id="forms.payNow.bankInfo.legend" defaultMessage="Banking Information"/>
					</h1>
				</div>

				<Form isBusy={props.isLoading} isValid={isValid} onSubmit={this._handleSubmit} submitLabel={messages.next} error={props.globalError} renderButtons={this._renderButtons}>
					<BankInfoFields {...props} disableBankSave={disableBankSave} errors={errors}/>
				</Form>
			</Fragment>);
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/secure/PayNowForm/BankInfoForm/BankInfoForm.tsx